import { Field, FieldFooter, IFormFieldDefaultProps } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import ColorPicker, { IColorPickerProps } from 'components/foundation/pickers/color-picker/ColorPicker/ColorPicker';
import { AnyObject } from 'types/util/Object';

export interface IColorPickerFormFieldProps<FormType extends AnyObject>
  extends Omit<IColorPickerProps, 'selectedColor' | 'error'>,
    IFormFieldDefaultProps<string, FormType> {}

function ColorPickerFormField<FormType extends AnyObject>(props: IColorPickerFormFieldProps<FormType>) {
  const { form, name, validations, onChange, className, ...other } = props;

  function renderField({ ...fieldProps }) {
    function handleOnChange(value: string) {
      fieldProps.handleChange(value, onChange);
    }

    const selectedColor = form.state.data[name];

    return (
      <>
        <ColorPicker {...other} onChange={handleOnChange} selectedColor={selectedColor} error={fieldProps.hasError} />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  const classes = classNames({}, className);

  return <Field className={classes} form={form} name={name} validations={validations} render={renderField} />;
}

ColorPickerFormField.defaultProps = {
  ...ColorPicker.defaultProps,
};

export default ColorPickerFormField;
